import { yup } from '@framework/validation';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema';
import { WidgetType } from '../../../Widget';
import { uniqueWidgetCodeSchema } from '../../../validation/uniqueWidgetCodeSchema';
import { CommonContainerWidgetConfigSchema } from '../../containers/common/CommonContainerWidgetConfigSchema';
import { ISubsectionWidget } from './ISubsectionWidget';
import { SubsectionRendering } from './SubsectionRendering';

export const SubsectionWidgetConfigSchema: yup.ObjectSchema<ISubsectionWidget> =
  CommonContainerWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Subsection).required(),
    code: uniqueWidgetCodeSchema,
    label: RichTextAdvancedSchema.optional().label('Titolo'),
    placeholder: yup
      .string()
      .optional()
      .label('Testo Pulsante')
      .default('Apri sottosezione')
      .when('rendering', ([rendering]: SubsectionRendering[], schema) => {
        return rendering === SubsectionRendering.Drawer
          ? schema.required()
          : schema.strip();
      }),
    rendering: yup
      .string()
      .oneOfEnum(SubsectionRendering)
      .required()
      .default(SubsectionRendering.Drawer)
      .label('Visualizzazione'),
    viewInResume: yup
      .boolean()
      .notRequired()
      .default(false)
      .label('Visualizza in riepilogo'),
  })
    .required()
    .noUnknown();
